// External library
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Component
export default class FaqMulti {
    constructor () {
        this.faq = document.querySelector('[data-faq-multi]')
        this.sidebar = this.faq
            ?.querySelector('[data-faq-multi-sidebar]')
        this.sidebarItems = this.sidebar
            ?.querySelectorAll('a')

        // If there isn't a FAQ sidebar OR isn't a large device
        if (!this.sidebarItems || window.innerWidth < 1024)
            return

        this.start()
    }

    start () {
        ScrollTrigger.matchMedia({
            '(min-width: 1024px)': () => {
                const topDistance = 150
                const bottomDistance = topDistance
                    + this.sidebar.offsetHeight

                // PIN sidebar
                ScrollTrigger.create({
                    pin: this.sidebar,
                    trigger: this.faq,
                    start: `-${topDistance}px top`,
                    end: `bottom+=-80px ${bottomDistance}px`
                })

                const faqGroups = this.faq
                    .querySelectorAll(`.${this.faq.dataset.faqMulti}`)

                // UPD sidebar active item
                faqGroups.forEach(group => {
                    gsap.to(group, {
                        scrollTrigger: {
                            trigger: group,
                            start: 'top center',
                            end: 'bottom center',
                            onToggle: (el) => el.isActive
                                && this.sidebarControl(el)
                        }
                    })
                })
            }
        })
    }

    sidebarControl (el) {
        const group = el
            ?.vars
            ?.trigger

        if (!group)
            return

        const groupId = group.getAttribute('id')

        const updClass = (add, el) => {
            el.closest('li')
                ?.classList[add
                    ? 'add'
                    : 'remove'
                ]('kanga-faq-sidebar-item-active')
        }

        this.sidebarItems.forEach(el =>
            updClass(el.getAttribute('href') === `#${groupId}`, el))
    }
}
